import { render, staticRenderFns } from "./CustomerProfileCard.vue?vue&type=template&id=3207df39&"
import script from "./CustomerProfileCard.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports